var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404"},[_c('div',{staticClass:"error404-body-con"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"error404-body-con-title"},[_vm._v("4\n        "),_c('span',[_vm._v("0")]),_vm._v("4")]),_c('p',{staticClass:"error404-body-con-message"},[_vm._v("未查询到数据，蚌埠住了")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }